export enum IRegistrationType {
  new = 'new',
  old = 'old',
}
